import React from 'react';
import { stripeSuccess } from "../../../data/loca/stripe";
export async function loader() {

    let params = new URLSearchParams(document.location.search);
    let payment_intent = params.get("payment_intent"); 
    let payment_intent_client_secret = params.get("payment_intent_client_secret"); 
    let resp = await stripeSuccess(payment_intent, payment_intent_client_secret);
    return null;
}

export default function StripeDepositSuccess() {
   

    return (
        <div className="endPayment">
            <div id="thumbnail">


                <div className="depositSuccess">

                    <h2>La caution a été déposée avec succès ! Le loueur en a été informé.</h2>
                 
                    <i className="pi pi-check-circle" style={{ fontSize: '3rem' }}></i>
                </div>
                

            </div>

        </div>
        
    )            
}